import {
  allProductFlags,
  ProductEnvironmentFlags,
} from "../models/ProductFlags";

const ALL_PRODUCT_FLAGS_AS_FALSE = allProductFlags.reduce((acc, currentKey) => {
  acc[currentKey] = false;

  return acc;
}, {} as ProductEnvironmentFlags);

const ALL_PRODUCT_FLAGS_AS_TRUE = allProductFlags.reduce((acc, currentKey) => {
  acc[currentKey] = true;

  return acc;
}, {} as ProductEnvironmentFlags);

export const DEFAULT_PRODUCT_FLAGS_VALUE = {
  sandbox: ALL_PRODUCT_FLAGS_AS_FALSE,
  production: ALL_PRODUCT_FLAGS_AS_FALSE,
};

export const ALL_ACTIVE_PRODUCT_FLAGS_VALUE = {
  sandbox: ALL_PRODUCT_FLAGS_AS_TRUE,
  production: ALL_PRODUCT_FLAGS_AS_TRUE,
};
